// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BallScaleRippleMultiple_wrap_ON_ac","loader_simple":"BallScaleRippleMultiple_loader_simple_1r4ji","rotation":"BallScaleRippleMultiple_rotation_3l_13"};